/**
 * HomePage — Composes hero and what-we-do sections for the home route.
 */
import React from 'react';
import Hero from './Hero';
import WhatWeDo from './WhatWeDo';

function HomePage() {
  return (
    <>
      <Hero />
      <WhatWeDo />
    </>
  );
}

export default HomePage;
